import security from 'stores/security';

export interface AccDataTypes {
    beneficiary_bank?: string;
    beneficiary_bank_account?: string;
    beneficiary_bank_country_code?: string;
}

interface NoticeInfo extends AccDataTypes {
    customer_id?: number;
    account_id?: number;
    amount?: string;
    currency?: string;
    bank_account?: string;
    bank_country_code?: string;
    voucher_pictures?: string[];
    type?: string;
    tax_year?: string;
}

export const parseNoticeInfo = ($params, isIRA: boolean = false, bankInfo?) => {
    bankInfo = bankInfo || {};

    const keys = [
        'amount',
        'currency',
        'bank_account',
        'voucher_pictures',
        'voucher_pictures_front',
        'voucher_pictures_reverse',
        'beneficiary_bank',
        'beneficiary_bank_account',
        'beneficiary_bank_country_code',
        'bank'
    ];

    const params: NoticeInfo = {
        customer_id: security.currentCustomerId,
        account_id: security.currentAccountId
    };

    keys.forEach(item => {
        const value = $params[item] || bankInfo[item];

        if (value) {
            if (item.startsWith('voucher_pictures') && Array.isArray(value)) {
                params.voucher_pictures = params.voucher_pictures || [];

                for (const obj of value) {
                    if (obj.url) {
                        params.voucher_pictures.push(obj.url);
                    }
                }
            } else {
                params[item] = value;
            }
        }
    });

    if (isIRA) {
        params.tax_year = $params.tax_year;
    }

    return params;
};
